import React from 'react';
import { List, GitBranch } from 'lucide-react';
import './ViewModeToggle.css';

interface ViewModeToggleProps {
  currentMode: 'list' | 'flow';
  onModeChange: (mode: 'list' | 'flow') => void;
  disabled?: boolean;
  showBetaBadge?: boolean;
}

export const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  currentMode,
  onModeChange,
  disabled = false,
  showBetaBadge = true
}) => {
  return (
    <div className="view-mode-toggle">
      <button
        className={`toggle-btn ${currentMode === 'list' ? 'active' : ''}`}
        onClick={() => onModeChange('list')}
        disabled={disabled}
        title="List View - Sequential step-by-step view"
        aria-label="Switch to list view"
      >
        <List size={16} />
        <span>List</span>
      </button>
      
      <button
        className={`toggle-btn ${currentMode === 'flow' ? 'active' : ''}`}
        onClick={() => onModeChange('flow')}
        disabled={disabled}
        title="Flow Diagram - Visual workflow representation"
        aria-label="Switch to flow diagram view"
      >
        <GitBranch size={16} />
        <span>Flow</span>
        {showBetaBadge && currentMode === 'flow' && (
          <span className="beta-badge">Beta</span>
        )}
      </button>
    </div>
  );
};